import Date from '../../../../components/Date/Date'
import Initials from '../../../../components/Initials'

interface IInquiryDetail {
  id: string
  customerName: string
  email: string
  inquiryDate: string
  sku?: string
  productName?: string
  customerGroup?: string
  salesRep?: string
  notifyEmail?: string
  variantId?: string
}

const InquiryDetailsTableRow = ({
  row,
  isParentRow,
}: {
  row: IInquiryDetail
  isParentRow: boolean
}) => {
  return (
    <tr>
      <td>
        <Date date={row.inquiryDate} />
      </td>
      {isParentRow && (
        <td>
          <span className='badge badge-lg badge-light-primary'>{row.sku}</span>
        </td>
      )}
      <td>
        {row.customerName ? (
          <div className='d-flex align-items-center flex-grow-1 text-start cursor-pointer'>
            <div className='symbol symbol-circle symbol-35px me-3'>
              <Initials text={row.customerName?.charAt(0)} />
            </div>
            <div className='d-flex flex-column'>
              <div className='align-items-center text-dark fw-semibold'>{row.customerName}</div>
              <div className='align-items-center text-muted'>{row.email}</div>
            </div>
          </div>
        ) : (
          '-'
        )}
      </td>
      <td>{row.salesRep}</td>
      <td>{row.notifyEmail}</td>
    </tr>
  )
}
export default InquiryDetailsTableRow
